import { GtmService } from '@omnia/ui/src/lib/services/gtm/gtm.service'
import { sendNewAccountDataLayer } from '@/common/services/gtm/custom/new-account.gtm'
import { EventsGtmEvents } from '@/common/services/gtm/eccommerce/events.gtm'
import { FilmsGtmEvents } from '@/common/services/gtm/eccommerce/films.gtm'
import { SubscriptionsGtmEvents } from '@/common/services/gtm/eccommerce/subscriptions.gtm'
import { TicketingGtmEvents } from '@/common/services/gtm/eccommerce/ticketing.gtm'
import type { CurzonEcommerceDataLayer } from '@/common/services/models-gtm'
import { getMembershipTier } from '@/common/utils/memberHelper'

class CurzonGtmService extends GtmService {
    constructor() {
        super()
    }
    async sendEcommerceDataLayer(dataLayerObj: CurzonEcommerceDataLayer) {
        dataLayerObj.membership_tier = await getMembershipTier()
        super.sendDataLayer(dataLayerObj)
    }
    public ecommerce = {
        events: EventsGtmEvents,
        films: FilmsGtmEvents,
        subscriptions: SubscriptionsGtmEvents,
        ticketing: TicketingGtmEvents,
    }

    public customEvents = {
        newAccount: sendNewAccountDataLayer,
    }
}

export const gtm = new CurzonGtmService()
